import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import Buttons from '../../Constans/Buttons';
import {hideAppLoader, showAppLoader} from '../../../../Shared/Loader/LoaderSlice';
import {useDispatch} from 'react-redux';
import {GetPriceByPaymentCount, setSelectedPhone} from '../../IdfSaleSlice';
import {Label} from 'reactstrap';
import SelectInput from '../../../../Shared/SelectInput/SelectInput';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import PopUp from '../../../../Shared/Popup/PopUp';
import OutOfStockPopUp from '../../PopUps/OutOfStockPopUp';
import OnlySimProcess from './OnlySimProcess';
import {isAllowedEsim} from '../../IdfSaleEnums';
import EsimPopUp from '../../PopUps/EsimPopUp';
import stageConfig from 'app/StageConfig';
import {buildUrlAndOpenWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import ErrorPage from '../../PopUps/ErrorPage';
import {dwhReport, dwhDictionary} from '../../dwhReports/dwhGeneralReport';

function PhoneOptions(props) {
  const dispatch = useDispatch();
  //props.saveToHistory('DeviceSelectionStepTwo');

  const {phoneFeatureList: phoneList} = props.idfStore;
  const {user_type_id: userType} = props.idfStore.userDetails;
  const [error, setError] = useState(false);
  const [errorCode, setErrorCode] = useState('');
  const [selectedColor, setSelectedColor] = useState('hidden');
  const [selectedColorObj, setSelectedColorObj] = useState({});
  const [selectedPayment, setSelectedPayment] = useState(
    props.idfStore.isLeasing ? 18 : phoneList?.[0]?.paymentCounts?.[phoneList[0]?.paymentCounts.length - 1] || '',
  );

  const image = phoneList?.[0]?.imagePhoneUrl?.split('\\');
  const filename_i = image != null && image[image.length - 1];
  const details = phoneList?.[0]?.imageDetailsUrl?.split('\\');
  const filename_d = details != null && details[details.length - 1];

  // console.log(`../../images/${filename}`);
  const [priceByPayments, setPriceByPayments] = useState();
  const [paymentType, setPaymentType] = useState('INVOICE');
  const [insuranceOption, setInsuranceOption] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [canContinue, setCanContinue] = useState(false);
  const [showOutOfStockPopUp, setShowOutOfStockPopUp] = useState(false);

  // console.log(phoneList?.[0]?.paymentCounts?.[phoneList[0]?.paymentCounts.length - 1]);
  const [showEsimPopup, setShowEsimPopup] = useState(false);

  useEffect(() => {
    showAppLoader();
    if (phoneList == null) {
      props.setDeviceSelectionStep(1);
      hideAppLoader();
    } else {
      getPriceByPayments(selectedPayment);

      hideAppLoader();
    }
  }, [phoneList]);

  if (phoneList == null) {
    return <></>;
  }

  useEffect(() => {
    calculatePrice(priceByPayments);
  }, [priceByPayments, insuranceOption]);

  useEffect(() => {
    checkIfCanContinue();
  }, [selectedColor, insuranceOption, , paymentType, selectedPayment]);

  const [fieldErrors, setFieldErrors] = useState({
    selectedColor: false,
    selectedPayment: false,
    paymentType: false,
    insuranceOption: false,
  });

  const checkIfCanContinue = () => {
    setFieldErrors({
      selectedColor: false,
      selectedPayment: false,
      paymentType: false,
      insuranceOption: false,
    });
    let hasError = false;

    // Check if required fields are missing
    if (!selectedColor || selectedColor === 'hidden' || !selectedColorObj.inStock) {
      setFieldErrors((prevErrors) => ({...prevErrors, selectedColor: false}));
      hasError = true;
    }

    if (!selectedPayment) {
      setFieldErrors((prevErrors) => ({...prevErrors, selectedPayment: true}));
      hasError = true;
    }

    if (!paymentType) {
      setFieldErrors((prevErrors) => ({...prevErrors, paymentType: true}));
      hasError = true;
    }

    if (!insuranceOption.value) {
      setFieldErrors((prevErrors) => ({...prevErrors, insuranceOption: true}));
      hasError = true;
    }

    if (hasError) {
      setCanContinue(false);
    } else {
      setCanContinue(true);
    }
  };

  const handleContinueClick = async () => {
    const selectedPhoneObject = {
      ...phoneList[0],
      selectedColor,
      selectedPayment,
      paymentType,
      insuranceOption: insuranceOption?.value || false,
      warrantyPrice: insuranceOption?.price || 0,
      price: priceByPayments,
      totalPrice,
    };
    await dispatch(setSelectedPhone({selectedPhone: selectedPhoneObject}));

    var canContinue = await props.onClickNavigation(selectedPhoneObject);
    if (!canContinue) {
      return false;
    }
    if (props.idfStore.simType === 'eSIM') {
      return setShowEsimPopup(true);
    }
    var phoneDetails = `, צבע :${selectedColor} , מס תשלומים: ${selectedPayment}מכשיר: ${phoneList[0].groupName}  `;
    dwhReport({...dwhDictionary.DeviceSelection_Completed, param1: phoneDetails});
    return true;
  };
  async function getPriceByPayments(payments) {
    const res = await dispatch(
      GetPriceByPaymentCount({count: payments, itemId: phoneList?.[0].item_id, isLeasing: props.idfStore.isLeasing}),
    );
    if (res.payload?.price != null) {
      setPriceByPayments(res.payload.price);
    } else {
      setErrorCode(62);
      setError(true);
    }
  }
  const handleColorChange = (color) => {
    setSelectedColor(color);
    const currPhoneObject = phoneList.find(({colour}) => colour === color);
    setSelectedColorObj(currPhoneObject);
    !currPhoneObject.inStock && setShowOutOfStockPopUp(true);
  };

  const handlePaymentChange = (payment) => {
    setSelectedPayment(payment);
    getPriceByPayments(payment);
  };

  function calculatePrice(price) {
    if (typeof price === 'undefined') {
      return;
    }

    const phonePriceToInt = Math.round(parseFloat(price) * 100) / 100;
    const warrantyPriceToInt = userType === 'Regular' ? Math.round(parseFloat(props.contentData.warrantyPrice.value) * 100) / 100 : 0;
    let calculatedTotalPrice;

    if (insuranceOption.value === 'ADD_INSURANCE') {
      calculatedTotalPrice = phonePriceToInt + warrantyPriceToInt;
    } else {
      calculatedTotalPrice = phonePriceToInt;
    }

    setTotalPrice(calculatedTotalPrice.toFixed(2));
  }
  const onEsimPopUpClose = () => {
    setShowEsimPopup(false);
    let el = document.getElementsByTagName('body')[0];
    el.classList.remove('modal-open');
  };
  if (error) {
    return <ErrorPage errorCode={errorCode} />;
  } else {
    return (
      <div className='phone-options-container'>
        <div className='photo-container'>
          <Image className='phone-image' src={`${stageConfig.staticWebSiteUrl}/idfImages/images/${filename_i}`} alt='Main Image' />
        </div>
        <h1>{phoneList[0]?.modelName + 'GB'}</h1>
        <div className='idf-line justify-content-center d-flex'></div>
        <div className='links-and-esim-info-container'>
          <div className='d-flex align-items-center'>
            <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <rect
                x='6'
                y='22.048'
                width='18.546'
                height='12'
                rx='1.5'
                transform='rotate(-90 6 22.048)'
                fill='#E0C1FF'
                stroke='var(--theme-primary, #810ea9)'
                stroke-width='1.5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <circle cx='11.999' cy='18.884' r='1.2' transform='rotate(-180 12 18.884)' fill='var(--theme-primary, #810ea9)' />
            </svg>

            <Label check>
              {' '}
              <div
                style={{cursor: 'pointer', color: 'var(--theme-primary, #9631ff)'}}
                onClick={() => buildUrlAndOpenWindow(`${stageConfig.staticWebSiteUrl}/idfImages/details/${filename_d}`)}>
                לצפייה במפרט המכשיר{' '}
              </div>
            </Label>
          </div>
        </div>
        <div className='question-container'>
          <label className='idf-sub-title-bold' htmlFor='colorSelect'>
            איזה צבע בא לך?
          </label>
          <SelectInput
            onChange={(e) => handleColorChange(e.target.value)}
            options={phoneList.map((phone) => ({colorSelect: phone.colour, name: phone.colour}))}
            dataKey='colorSelect'
            dataValue='name'
            defaultText='בחר צבע'
            value={selectedColor}
            placeholder='בחר צבע'
          />
        </div>
        <PopUp
          preventWrapperClose={true}
          showPopUp={showOutOfStockPopUp}
          onClose={() => {
            setShowOutOfStockPopUp(false);
            setSelectedColor('hidden');
          }}>
          <OutOfStockPopUp
            Cat_no={selectedColorObj.refmat}
            Color={selectedColorObj.colour}
            Phone_Name={selectedColorObj.modelName}
            onClose={() => {
              setShowOutOfStockPopUp(false);
              setSelectedColor('hidden');
            }}
            setShowPopUp={showOutOfStockPopUp}
            handleNotifyUser={() => {}}></OutOfStockPopUp>
        </PopUp>
        {!props.idfStore.deviceUpgradeProcessing && props.idfStore.lineType != 2 && (
          <div className='question-container'>
            <OnlySimProcess
              simType={props.idfStore.simType}
              setSimType={props.setSimType}
              isShowEsim={props.contentData.eSimFlag.value}
              isAllowedEsim={() => isAllowedEsim({store: props.idfStore, esimFlag: props.contentData.eSimFlag.value})}
              {...props}></OnlySimProcess>
          </div>
        )}
        {/* <div className='question-container'>
          <label className='idf-sub-title-bold' htmlFor='colorSelect'>
            איך תרצו לשלם?{' '}
          </label>

         <div className='radio-input-container'>
            <RadioInput
              checked={paymentType === 'INVOICE' || props.idfStore.isLeasing}
              id={'invoice'}
              name={'paymentType'}
              value={'INVOICE'}
              label={'תשלום חודשי בחשבונית'}
              onRadioChange
              onChange={(e) => setPaymentType(e.target.value)}
            />
            {!props.idfStore.isLeasing && (
              <RadioInput
                checked={paymentType === 'OUTINVOICE'}
                id={'outinvoice'}
                name={'paymentType'}
                value={'OUTINVOICE'}
                label={'תשלום בנפרד מהחשבונית'}
                subLabel={'אמסור את פרטי הכרטיס במרכז שירות(תקף איסוף עצמי בלבד)'}
                onChange={(e) => setPaymentType(e.target.value)}
              />
            )}
          </div>
        </div>*/}
        <div className='question-container'>
          <label className='idf-sub-title-bold' htmlFor='paymentSelect'>
            לכמה תשלומים לחלק?{' '}
          </label>
          <SelectInput
            onChange={(e) => handlePaymentChange(e.target.value)}
            options={
              props.idfStore.isLeasing
                ? [{paymentSelect: 18, name: 18}]
                : phoneList[0]?.paymentCounts.map((count) => ({paymentSelect: count, name: count}))
            }
            dataKey='paymentSelect'
            dataValue='name'
            defaultText='בחר מספר תשלומים'
            disabled={props.idfStore.isLeasing}
            value={props.idfStore.isLeasing ? 18 : selectedPayment}
          />
        </div>
        <div className='question-container'>
          <label className='idf-sub-title-bold' htmlFor='colorSelect'>
            להוסיף לך שירות תיקונים מקיף?
          </label>
          <label className='idf-description-bold' htmlFor='colorSelect'>
            כולל את כל סוגי התקלות לרבות נזקי תצוגה. במכשירי פרימיום עלות החלפת מסך מהמקרה השני ואילך- 60% מערך העלות ללקוח פרטי{' '}
          </label>
          <div className='radio-input-container'>
            <RadioInput
              checked={insuranceOption.value === 'NO_INSURANCE'}
              id={'no-insurance'}
              name={'insuranceOption'}
              value={'NO_INSURANCE'}
              label={'אל תוסיפו לי שירות תיקונים'}
              onChange={(e) => setInsuranceOption({value: e.target.value, price: 0})}
            />
            <RadioInput
              checked={insuranceOption.value === 'ADD_INSURANCE'}
              id={'insurance'}
              name={'insuranceOption'}
              value={'ADD_INSURANCE'}
              label={'תוסיפו לי שירות תיקונים'}
              price={userType === 'Regular' && `₪${props.contentData.warrantyPrice.value} לחודש כולל מע"מ`}
              onChange={(e) => setInsuranceOption({value: e.target.value, price: props.contentData.warrantyPrice.value})}
            />
          </div>
        </div>
        <div className='price-container'>
          <div className='phone-price'>
            <div className='price'>
              <span className='phone-title idf-description-bold '>{phoneList[0]?.modelName + 'GB'}</span>
              <span className='phone-price idf-description-bold'>
                {' '}
                {priceByPayments && '₪' + Math.round(parseFloat(priceByPayments) * 100) / 100}
              </span>
            </div>
            <div className='price'>
              <span className='idf-title-small-gray'>חיוב בגין ציוד</span>
              <span className='idf-title-small-gray align-left'>
                {' '}
                {priceByPayments && '₪' + (priceByPayments / selectedPayment).toFixed(2) + 'X' + selectedPayment}{' '}
              </span>
            </div>
          </div>
          {insuranceOption.value === 'ADD_INSURANCE' && (
            <>
              <div className='divider'></div>
              <div className='insurance-price'>
                <div className='price'>
                  <span className='insurance-title  idf-description-bold '>שירות תיקונים</span>
                  <span className='insurance-price  idf-description-bold'>
                    {' '}
                    ₪ {userType === 'Regular' ? props.contentData.warrantyPrice.value : '0'}
                  </span>
                </div>
                <div className='price'>
                  <span className='idf-title-small-gray'>חיוב חודשי</span>
                </div>
              </div>
            </>
          )}
        </div>
        <div className='idf-sale-buttons-container'>
          <Buttons
            onClickNavigation={handleContinueClick}
            isForm={false}
            setIsSubmit={''}
            canContinue={canContinue}
            btnContinueText={'בחרתי אפשר להתקדם'}
          />
        </div>{' '}
        <PopUp preventWrapperClose={true} showPopUp={showEsimPopup} onClose={() => setShowEsimPopup(false)} className=''>
          <EsimPopUp {...props} onEsimPopUpClose={onEsimPopUpClose} {...props} />
        </PopUp>
      </div>
    );
  }
}

export default PhoneOptions;
